<template>
  <Page
    :step="step"
    :desktop="desktop"
    :title="title"
    :message="message"
    :inputs="totalInputs"
    :finished="touchedInputs"
  >

    <div
      class="input-wrap checkbox-wrap"
      v-if="names.length > 1"
    >
      <div>
        <input
          type="checkbox"
          class="checkbox"
          name="checkboxes"
          value="check_1"
          checked>
      </div>
      <label for="checkbox">
        Same address for all children
      </label>
    </div>

    <transition
      name="fade"
      mode="out-in">
      <div
        class="address-search"
        v-if="!fullAddress"
      >
        <div class="input-wrap">
          <label for="postcode">Postcode</label>
          <div
            class="icon-inner-wrap"
            id="postcode">
            <input
              aria-required="true"
              type="text">
          </div>
        </div>

        <button
          class="btn cta default"
          @click="findAddress"
        >Find my address<i class="fa fa-search"/></button>

        <transition name="fade">
          <div
            class="input-wrap"
            v-if="addressSelector"
          >
            <label for="signup-details__address__select">Choose your address</label>
            <select
              name="delivery_address_select"
              @change="openFullAddress"
            >
              <option
                selected="selected"
                disabled="disabled"
                hidden="hidden"
                value=""/>
              <option value="default">1 Street-name, Town-name</option>
            </select>
          </div>
        </transition>

      </div>

      <FullAddress
        v-else
        :validinputs="dumbInputsValid"
      />
    </transition>

    <a @click="openFullAddress">{{ fullAddress ? 'Look up another address' : 'Or enter your address manually' }}</a>

    <button
      class="success cta continue-button"
      @click="next">Continue<i class="fa fa-play"/></button>
  </Page>
</template>

<script>
import Page from '../library/page.vue'
import FullAddress from '../library/full-address.vue'

export default {
  name: 'Address',
  props: {
    step: {
      type: Number,
      default: 0
    },
    desktop: {
      type: Boolean,
      default: true
    },
    names: {
      type: Array,
      default: function () { return [] }
    }
  },
  components: {
    Page,
    FullAddress
  },
  data () {
    return {
      title: 'Address',
      message: 'Boxes fit through a standard letterbox.',
      fullAddress: false,
      addressSelector: false,
      totalInputs: 1,
      touchedInputs: 0,
      dumbInputsValid: false,
      inputTimer: null
    }
  },
  methods: {
    next: function (event) {
      this.$emit('next')
      this.$emit('update-signup-object')
    },
    incrementInput: function (event) {
      clearTimeout(this.inputTimer)
      this.inputTimer = setTimeout(() => {
        if (this.touchedInputs < this.totalInputs && !event.target.parentNode.classList.contains('valid')) {
          this.touchedInputs++
        }
        event.target.parentNode.classList.add('valid')
      }, 250)
    },
    findAddress: function (event) {
      this.addressSelector = !this.addressSelector
    },
    openFullAddress: function (event) {
      this.fullAddress = !this.fullAddress
      this.addressSelector = false
      this.incrementInput(event)
      this.dumbInputsValid = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .default {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/address.vue